import React from 'react'

const SubNav = ({head}) => {
    return (
        <div className='sub_nav_container'>
            <h4> {head}</h4>
        </div>
    )
}

export default SubNav
